// @ts-check

import {
  RESET_TO_DEFAULT,
  DEFAULT_BACKGROUND,
} from "src/components/BannerImagePicker/consts";
import useGetBranding from "src/hooks/useGetBranding";

/**
 * @param {Object} params
 * @param {string} params.attributeType
 * @param {teamform.attributes.BaseEntityAttribute[]} params.attributes
 */
export const useGetDefaultBackgroundItem = ({ attributes, attributeType }) => {
  const branding = useGetBranding();
  const bannerAttr = attributes?.find(
    (attr) => attr.attributeType === attributeType
  );
  if (
    bannerAttr &&
    bannerAttr.value &&
    bannerAttr.value !== branding?.gradients
  ) {
    return {
      id: DEFAULT_BACKGROUND,
      description: "Default",
      width: 800,
      height: 450,
      color: branding?.gradients,
      type: DEFAULT_BACKGROUND,
      data: { type: RESET_TO_DEFAULT },
    };
  }
  return null;
};
